__turbopack_context__.v({
  "icon": "nO6MwG_icon",
  "inner": "nO6MwG_inner",
  "pagination": "nO6MwG_pagination",
});
